"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const antd_1 = require("complex-component/antd");
exports.default = (0, vue_1.defineComponent)({
    name: 'MutipleForm',
    components: {
        ComplexEditForm: antd_1.ComplexEditForm
    },
    props: {
        dictionary: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: false
        },
        typeList: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {};
    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.typeList.forEach((val, index) => {
                    this.$refs.form[index].show(val, 'change', this.data);
                });
            });
        }
    }
});
